module.exports = __webpack_public_path__ + "static/media/bookings.16f15c70.svg";